// src/config/pages.js
// Centrale registry van afgeschermde pagina's voor toegangsbeheer per gebruiker.
// Eén bron van waarheid voor: de sidebar, de route-guard (App.js) en het
// pagina-toegang-overzicht in Gebruikersbeheer.
//
// Toegangsmodel (allowedPages op de gebruiker):
//   - lege lijst []      => volledige toegang (standaard voor bestuursleden)
//   - gevulde lijst [..] => whitelist; gebruiker mag ALLEEN die pagina's zien
//                           (de huismeester is vast vergrendeld op ['schilder'])

export const PAGES = [
  { key: 'beheer',          path: '/beheer',          label: 'Beheerdersportaal' },
  { key: 'newsletter',      path: '/newsletter',      label: 'Nieuwsbrieven' },
  { key: 'energie',         path: '/energie',         label: 'Energieverbruik' },
  { key: 'bewoners',        path: '/bewoners',        label: 'Bewonersbeheer' },
  { key: 'opnamestaten',    path: '/opnamestaten',    label: 'Opnamestaten' },
  { key: 'faq-admin',       path: '/faq-admin',       label: 'FAQ Beheer' },
  { key: 'planning-admin',  path: '/planning-admin',  label: 'Planning Projecten' },
  { key: 'cv-controle-admin', path: '/cv-controle-admin', label: 'CV-controle meldingen' },
  { key: 'schilderwerk',    path: '/schilderwerk',    label: 'Schilderwerk balkons' },
  { key: 'schilder',        path: '/schilder',        label: 'Huismeester-app' },
  { key: 'schoonmaak-admin', path: '/schoonmaak-admin', label: 'Schoonmaak' },
  { key: 'analytics',       path: '/analytics',       label: 'Website Analytics' },
  { key: 'user-management', path: '/user-management', label: 'Gebruikersbeheer' },
];

// Pagina's die altijd bereikbaar zijn, ook voor een whitelist-gebruiker.
const ALWAYS_ALLOWED_PATHS = ['/', '/home', '/login'];

// Zoek de pagina-definitie die bij een pad hoort (prefix-match, bv. /planning-admin/123).
export function pageForPath(pathname) {
  return PAGES.find(
    (p) => pathname === p.path || pathname.startsWith(p.path + '/')
  );
}

// Mag deze gebruiker dit pad zien?
//   allowedPages leeg/undefined => volledige toegang.
//   anders whitelist op basis van pagina-key.
export function isPathAllowed(pathname, allowedPages) {
  if (!Array.isArray(allowedPages) || allowedPages.length === 0) return true;
  if (ALWAYS_ALLOWED_PATHS.includes(pathname)) return true;

  const page = pageForPath(pathname);
  // Onbekende afgeschermde route + whitelist-gebruiker => blokkeren.
  if (!page) return false;
  return allowedPages.includes(page.key);
}

// Bepaal waar een whitelist-gebruiker naartoe moet als de huidige pagina niet mag.
export function firstAllowedPath(allowedPages) {
  if (!Array.isArray(allowedPages) || allowedPages.length === 0) return '/home';
  const first = PAGES.find((p) => allowedPages.includes(p.key));
  return first ? first.path : '/home';
}

// Lees de opgeslagen pagina-rechten van de ingelogde gebruiker uit localStorage.
export function getStoredAllowedPages() {
  try {
    const raw = localStorage.getItem('allowedPages');
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function getStoredRole() {
  return localStorage.getItem('userRole') || '';
}
